// extracted by mini-css-extract-plugin
export default {"cmsContent":"Disclaimer_cmsContent__YajuB"};